module.exports = __webpack_public_path__ + "static/img/collapse.b7a495d7.svg";